import { Tabs } from "@components/tabs-nav/TabNav.types";

export const SystemProsTabs: Tabs = {
  Operations: {
    Banner: { id: "ops-banner", name: "Banner" }
  },
  SiteIntegration: {
    TenantSyncState: {
      id: "pros-tenant-sync-state",
      name: "Tenant Sync State"
    },
    DeploymentManagement: {
      id: "pros-deployment-management",
      name: "Deployment Management"
    }
  }
};
